import AuthLayout from "components/AuthLayout";
import Form from "./components/Form";
import { useAuth } from "hooks/useAuth";

const ResetPassword = () => {
  const { changePassword, isLoading } = useAuth();

  return (
    <AuthLayout className="w-[400px] p-4 max-h-[520px] h-full flex items-center justify-center">
      <Form changePassword={changePassword} isLoading={isLoading} />
    </AuthLayout>
  );
};

export default ResetPassword;
